import { DOCS_FORM_NAMES } from "core/consts";
import { FormFieldConfig } from "../..";
import { MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS } from "../Cardiology/sections";
import { DischargeLetterTextarea } from "../DischargeLetterTextarea";

export const DischargeLetterENTFormSections: FormFieldConfig<
  typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_ENT
>["sections"] = [
  {
    fields: {
      additional_diagnostic_findings: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .additionalDiagnosticFindings
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="additional_diagnostic_findings"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 7,
      },
      admission_medications: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .admissionMedication
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="admission_medications"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 5,
      },
      anamnesis: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames.anamnesis
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="anamnesis"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 4,
      },
      clinical_course: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .clinicalCourse
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="clinical_course"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 9,
      },
      diagnoses: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames.diagnoses
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="diagnoses"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 1,
      },
      discharge_medications: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .dischargeMedications
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="discharge_medications"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 10,
      },
      laboratory_parameters: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .laboratoryParameters
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="laboratory_parameters"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 8,
      },
      parameters: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames.parameters
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="parameters"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 6,
      },
      recommendations: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .recommendations
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="recommendations"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 11,
      },
      therapy: {
        input: ({ fieldRating, onFieldFeedback, translations }) => (
          <DischargeLetterTextarea
            fieldRating={fieldRating}
            label={
              translations.extractDocs.dischargeLetter.formFieldNames.therapy
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="therapy"
            onFieldFeedback={onFieldFeedback}
          />
        ),
        position: 3,
      },
    },
    position: 1,
    title: ({ translations }) =>
      translations.extractDocs.dischargeLetter.formEnt.sectionTitle,
  },
];
